module.exports = __webpack_public_path__ + "img/kakao.e8eb7750.png";